import React, { useState, useEffect } from "react";
import Layout from "../shared/Layout";
import DataTable from 'react-data-table-component';
import { GetCustomOrder } from "../../_services";
import { handleExport } from "../../_services/excelExportService";

const CustomOrder = () => {
    const [loading, setLoading] = useState(false);
    const [filteredData, setFilteredData] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    const [customOrder, setCustomOrder] = useState([]);

    const fetchCustomOrderDetail = async () => {
        try {
            const data = await GetCustomOrder();

            if (data?.isSuccess === 1) {
                setCustomOrder((prevData) => {
                    if (JSON.stringify(prevData) !== JSON.stringify(data?.data)) {
                        const sortedData = data?.data?.sort((a, b) => {
                            return new Date(b.createdDate) - new Date(a.createdDate);
                        });
                        return sortedData;
                    }
                    return prevData;
                });
            } else {
                setCustomOrder([])
            }
        } catch (error) {
            setCustomOrder([]);
        } finally {
            setLoading(false);
        }
    };


    useEffect(() => {
        fetchCustomOrderDetail();
    }, []);

    // const onDeleteCustomRequest = async (id) => {
    //     const isConfirmed = window.confirm("Are you sure you want to delete this item?");

    //     if (!isConfirmed) {
    //         return;
    //     }
    //     const data = await DeleteCustomOrderById(id);
    //     if (data.isSuccess === 1) {
    //         fetchCustomOrderDetail();
    //         toast.success("Delete Successfully");
    //     }
    // };

    useEffect(() => {
        if (searchTerm) {
            const filtered = customOrder.filter(item =>
                (item.name && item.name.toLowerCase().includes(searchTerm.toLowerCase())) ||
                (item.emailId && item.emailId.toLowerCase().includes(searchTerm.toLowerCase())) ||
                (item.mobileNo && item.mobileNo.toString().toLowerCase().includes(searchTerm.toLowerCase())) // Convert mobileNo to string
            );
            setFilteredData(filtered);
        } else {
            setFilteredData(customOrder);
        }
    }, [searchTerm, customOrder]);

    const excelSheetData = customOrder?.map((item, index) => ({
        Index: index + 1,
        Name: item.name,
        EmailId: item.emailId,
        MobileNo: item.mobileNo,
        ProductName: item.productName,
        Breast: item.breastSize,
        Weist: item.weistSize,
        Hip: item.hipSize,
        Shoulder: item.shoulder,
        Armhole: item.armhole,
    }));

    const columns = [
        {
            name: 'SR.No',
            selector: (row, index) => index + 1,
            sortable: false,
            width: '80px',
        },
        {
            name: 'Name',
            selector: row => row.name,
            sortable: false,
            width: '150px'
        },
        {
            name: 'Contact info',
            selector: row => (
                <div className="email_mobile">
                    <h6>
                        <a href={`mailto:${row.emailId}`} onClick={(e) => e.preventDefault()}>{row.emailId}</a>
                    </h6>
                    <p className="mb-0">
                        <a href={`tel:${row.mobileNo}`} onClick={(e) => e.preventDefault()}>{row.mobileNo}</a>
                    </p>
                </div>
            ),
            sortable: false,
            width: '200px'
        },
        {
            name: 'Product Name',
            selector: row => row.productName,
            sortable: false,
            width: '150px',
        },
        {
            name: 'Breast',
            selector: row => row.breastSize,
            sortable: false,
            minwidth: '70px'
        },
        {
            name: 'Weist',
            selector: row => row.weistSize,
            sortable: false,
            minwidth: '70px'
        },
        {
            name: 'Hip',
            selector: row => row.hipSize,
            sortable: false,
            minwidth: '70px'
        },
        {
            name: 'Shoulder',
            selector: row => row.shoulder,
            sortable: false,
            minwidth: '70px'
        },
        {
            name: 'Armhole',
            selector: row => row.armhole,
            sortable: false,
            minwidth: '70px'
        },
        {
            name: 'Quantity',
            selector: row => row.quantity,
            sortable: false,
            minwidth: '70px'
        },
    ];

    return (
        <Layout>
            <div className="px-4">
                <div className="admin-page mt-3 d-sm-flex justify-content-between align-items-center">
                    <div className="admin-heading" style={{ gap: "20px" }}>
                        <h4 className="mb-0">Custom Order</h4>
                    </div>
                    <div className="d-md-flex align-items-center justify-content-end" style={{ gap: "20px" }}>
                        <div className="search-container ">
                            <input
                                type="text"
                                placeholder="Search..."
                                value={searchTerm}
                                onChange={(e) => setSearchTerm(e.target.value)}
                                className="form-control"
                            />
                        </div>
                        <button className="export_button" onClick={() => handleExport(excelSheetData)}><img src="./images/upload.png" alt="" className="export_icon" /><span>Export</span></button>
                    </div>
                </div>
                <div className="datatable mt-3">
                    <DataTable
                        columns={columns}
                        data={filteredData || []}
                        progressPending={loading}
                        progressComponent={<p>Loading...</p>}
                        pagination
                        highlightOnHover
                    />
                </div>
            </div>
        </Layout>
    )
}

export default CustomOrder;